import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  wrapper: {
    position: "relative"
  }
}));

export default useStyles;
//# sourceMappingURL=Autocomplete.styles.js.map
